class ConcernSection extends HTMLElement {
  constructor() {
    super();

    this.updateActiveConcern = this.updateActiveConcern.bind(this);
    this.removeActiveClass = this.removeActiveClass.bind(this);
  }

  connectedCallback() {
    this.listItems = this.querySelectorAll('.concern-list-item a');

    this.intializeComponent();
  }

  intializeComponent() {
    if (!this.listItems.length > 0) return;

    this.listItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (window.innerWidth > 1024) {
          e.preventDefault();
        }
        this.removeActiveClass();
        this.updateActiveConcern(item);
      });
    });

    // Set the first item as active by default
    this.updateActiveConcern(this.listItems[0]);
  }

  updateActiveConcern(itemChildLink) {
    const activeItem = itemChildLink.parentElement;
    const titleElement = this.querySelector('.concern-cta-title');
    const descriptionElement = this.querySelector('.concern-description');
    const imageElement = this.querySelector('.concern-image');
    const ctaElement = this.querySelector('.concern-desktop-cta');

    titleElement.textContent = activeItem.getAttribute('data-title');
    descriptionElement.textContent = activeItem.getAttribute('data-description');
    imageElement.src = activeItem.getAttribute('data-image');
    imageElement.alt = activeItem.getAttribute('data-title');

    // Link text
    ctaElement.innerText = activeItem.getAttribute('data-ctaLinkText');

    // Link href
    ctaElement.href = activeItem.getAttribute('data-ctaLink');

    this.removeActiveClass();

    // add active class to the clicked item
    itemChildLink.classList.remove('tw-text-primary-grey-mid');
    itemChildLink.classList.add('tw-text-primary-black', '!tw-border-black');
  }

  removeActiveClass() {
    this.listItems.forEach((item) => {
      item.classList.remove('tw-text-primary-black', '!tw-border-black');
      item.classList.add('tw-text-primary-grey-mid');
    });
  }
}

customElements.define('concern-section', ConcernSection);
